import React from 'react';
import { Heart } from 'lucide-react';
interface FooterProps {
  setCurrentPage: (page: 'home' | 'terms' | 'privacy') => void;
}
export function Footer({
  setCurrentPage
}: FooterProps) {
  const handleLegalClick = (page: 'terms' | 'privacy') => {
    setCurrentPage(page);
    window.scrollTo(0, 0);
  };
  const handleHomeClick = () => {
    setCurrentPage('home');
    window.scrollTo(0, 0);
  };
  return <footer className="bg-navy text-white py-12 px-6 border-t border-white/10" data-id="element-45">
      <div className="max-w-6xl mx-auto" data-id="element-46">
        <div className="grid md:grid-cols-4 gap-8 mb-12" data-id="element-47">
          {/* Brand Column */}
          <div className="md:col-span-2" data-id="element-48">
            <button onClick={handleHomeClick} className="text-2xl font-serif font-bold mb-4 hover:text-teal transition-colors text-left" data-id="element-49">
              The ER-Ready Mom Binder
            </button>
            <p className="text-white/70 max-w-sm leading-relaxed" data-id="element-50">
              Built for moms who carry too much — so you never walk into a visit
              unprepared.
            </p>
            <div className="flex items-center gap-2 mt-6 text-sm text-white/50" data-id="element-51">
              <span data-id="element-52">Made with</span>
              <Heart className="w-4 h-4 text-teal fill-teal" data-id="element-53" />
              <span data-id="element-54">for peace of mind.</span>
            </div>
          </div>

          {/* Product Column */}
          <div data-id="element-55">
            <h4 className="font-bold text-lg mb-4 text-teal" data-id="element-56">Product</h4>
            <ul className="space-y-3 text-white/80" data-id="element-57">
              <li data-id="element-58">
                <button onClick={handleHomeClick} className="hover:text-white transition-colors text-left" data-id="element-59">
                  Home
                </button>
              </li>
              <li data-id="element-60">
                <a href="#offer" className="hover:text-white transition-colors" data-id="element-61">
                  Get the Kit
                </a>
              </li>
              <li data-id="element-62">
                <a href="#faq" className="hover:text-white transition-colors" data-id="element-63">
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          {/* Legal Column */}
          <div data-id="element-64">
            <h4 className="font-bold text-lg mb-4 text-teal" data-id="element-65">Legal</h4>
            <ul className="space-y-3 text-white/80" data-id="element-66">
              <li data-id="element-67">
                <button onClick={() => handleLegalClick('terms')} className="hover:text-white transition-colors text-left" data-id="element-68">
                  Terms of Service
                </button>
              </li>
              <li data-id="element-69">
                <button onClick={() => handleLegalClick('privacy')} className="hover:text-white transition-colors text-left" data-id="element-70">
                  Privacy Policy
                </button>
              </li>
              <li data-id="element-71">
                <a href="mailto:hello@betterbysteps.com" className="hover:text-white transition-colors" data-id="element-72">
                  Contact Support
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-white/40" data-id="element-73">
          <p data-id="element-74">
            © {new Date().getFullYear()} Better By Steps LLC. All rights
            reserved.
          </p>
          <p data-id="element-75">This product is not medical advice.</p>
        </div>
      </div>
    </footer>;
}